import { gql } from '@apollo/client';

export const REMOVE_ACCOUNT_STATEMENT = gql`
  mutation deleteAccountStatement($input: DeleteAccountStatementItemInput) {
    deleteAccountStatement(input: $input) {
      commandId
      correlationId
    }
  }
`;
